import React, { useMemo } from "react";
import { Tabs } from "../../../../shared/components/ui/Tabs";
import { WelcomeMessage } from "../../../../shared/components/ui/WelcomeMessage";
import { useGetUserById } from "../../../users/services/userService";
import { useAuthStore } from "../../../../store";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../../routes/routes";

import { useTabState } from "../../../../shared/hooks/useTabState";
import { useGetBuildingById } from "../../../buildings/services/buildingService";
import { SwimmersTab } from "../../components/SwimmersTab/SwimmersTab";
import { NewsTab } from "../../components/NewsTab/NewsTab";
import { ActionButton } from "../../../../shared/components/layout/ActionButton";

const TAB_VALUES = ["banistas", "novedades"] as const;

export const LifeguardDashboardPage: React.FC = () => {
  const { user } = useAuthStore();
  const { data: currentUser } = useGetUserById(user?.id ?? "");
  const { data: building } = useGetBuildingById(user?.buildingId ?? "");
  const navigate = useNavigate();

  // Manage tab state via URL query parameter
  const [activeTab, setActiveTab] = useTabState({
    defaultTab: 0,
    indexToValue: (index) => TAB_VALUES[index] ?? null,
    valueToIndex: (value) => {
      const index = TAB_VALUES.indexOf(value as (typeof TAB_VALUES)[number]);
      return index >= 0 ? index : null;
    },
  });

  const handleRegisterSwimmer = () => {
    navigate(ROUTES.SWIMMERS.REGISTER);
  };

  const handleRegisterNew = () => {
    navigate(ROUTES.NEWS.REGISTER);
  };

  const rightContent = useMemo(() => {
    if (activeTab === 0) {
      return <ActionButton onClick={handleRegisterSwimmer} />;
    }
    if (activeTab === 1) {
      return <ActionButton onClick={handleRegisterNew} />;
    }
    return null;
  }, [activeTab]);

  const tabs = [
    {
      label: "Bañistas",
      content: <SwimmersTab />,
    },
    {
      label: "Novedades",
      content: <NewsTab />,
    },
  ];

  return (
    <div className="flex flex-col gap-4 px-3 sm:px-6 py-0">
      <WelcomeMessage name={currentUser?.name} />
      <div className="flex flex-col gap-0">
        <p className="text-md text-gray-900">{building?.name}</p>
        <p className="text-md text-gray-900">{building?.city?.name}</p>
      </div>
      <Tabs
        tabs={tabs}
        activeTab={activeTab}
        onTabChange={setActiveTab}
        rightContent={rightContent}
      />
    </div>
  );
};
